// @flow

import React, { type Node } from 'react';

import smartphoneTipSrc from './smartphone.svg';

import { TipsBox } from '../../../../organisms/tips-box';

export function HelpBox(): Node {
  return (
    <TipsBox
      title="Importante saber"
      tipsModel={[
        {
          imgSrc: smartphoneTipSrc,
          altText: 'question icon',
          tipText: (
            <>
              Acompanhe gratuitamente seus pagamentos e reembolsos ou tire dúvidas acessando <a href="https://ajuda.ebanx.com/hc/pt-br" target="__blank">ajuda.ebanx.com</a>
            </>
          ),
        },
      ]}
    />
  );
}
